import validate from "/home/node/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import aa_45global_45middleware_45global from "/home/node/app/shop/app/middleware/aa_globalMiddleware.global.ts";
import authenticated_45global from "/home/node/app/shop/app/middleware/authenticated.global.ts";
import category_45tree_45middleware_45global from "/home/node/app/shop/app/middleware/categoryTreeMiddleware.global.ts";
import redirect_45middleware_45global from "/home/node/app/shop/app/middleware/redirectMiddleware.global.ts";
import route_45history_45and_45product_45filters_45reset_45global from "/home/node/app/shop/app/middleware/routeHistoryAndProductFiltersReset.global.ts";
import manifest_45route_45rule from "/home/node/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  aa_45global_45middleware_45global,
  authenticated_45global,
  category_45tree_45middleware_45global,
  redirect_45middleware_45global,
  route_45history_45and_45product_45filters_45reset_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}